import { Pagination, Select, Typography } from "antd";
import React from "react";

const { Text } = Typography;

const ReusablePagination = ({
  pageSize,
  handlePageSizeChange,
  currentPage,
  total,
  handlePageChange,
}) => {
  return (
    <div>
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          marginTop: 16,
        }}
      >
        <div>
          <Text style={{ marginRight: 8 }}>Page Size</Text>
          <Select
            value={pageSize}
            onChange={handlePageSizeChange}
            style={{ width: 80, marginRight: 16 }}
          >
            <Select.Option value={10}>10</Select.Option>
            <Select.Option value={25}>25</Select.Option>
            <Select.Option value={50}>50</Select.Option>
            <Select.Option value={100}>100</Select.Option>
          </Select>
        </div>
        <Pagination
          current={currentPage}
          total={total}
          pageSize={pageSize}
          onChange={handlePageChange}
          showSizeChanger={false}
        />
      </div>
    </div>
  );
};

export default ReusablePagination;
